import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import InlineSvg from 'vue-inline-svg'

loadFonts()

createApp(App)
  .component('Svg', InlineSvg)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
